<template>
  <div>
    <v-card>
      <v-app-bar flat>
        <v-toolbar-title class="font-weight-medium">Tipos de Produtos</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn @click="handleNew" color="primary">
          <v-icon left>mdi-plus</v-icon> Adicionar
        </v-btn>

        <v-btn icon @click="getLocalCategories" :loading="loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          label="Pesquisar tipos"
          style="max-width: 350px"
          single-line
          hide-details
          clearable
          @click:append="getLocalCategories"
          @keydown.enter="getLocalCategories"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="categories"
        :disabled="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="A carregar..."
        fixed-header
        max-height="500px"
      >
        <template v-slot:item.image_url="{ item }">
          <v-avatar rounded size="62" class="my-2">
            <v-img :src="item.image_url">
              <template v-slot:placeholder>
                <v-overlay absolute>
                  <v-icon>mdi-image-off</v-icon>
                </v-overlay>
              </template>
            </v-img>
          </v-avatar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-on="on" v-bind="attrs">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="handleEdit(item)">
                <v-icon left size="20">mdi-pencil</v-icon>
                <v-list-item-title>Alterar</v-list-item-title>
              </v-list-item>
              <v-list-item value="true" @click="confirmDelete(item)">
                <v-icon left size="20">mdi-delete</v-icon>
                <v-list-item-title>Remover</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="local_category_dialog" max-width="600" persistent>
      <LocalCategoryForm
        :category="local_category_editing"
        @submit="handleSubmitLocalCategoryForm"
        @cancel="handleCloseLocalCategoryForm"
      />
    </v-dialog>

    <confirm-delete-dialog
      :confirm_deletion="confirm_deletion"
      @deleteRecord="handleRemove"
      message="A categoria será excluída permanentemente"
    />
  </div>
</template>

<script>
import {
  index as indexLocalCategories,
  store as storeLocalCategories,
  destroy as destroyLocalCategory
} from "../services/local_categories";
import LocalCategoryForm from '../components/forms/LocalCategoryForm';
import ConfirmDeleteDialog from '../components/ConfirmDeleteDialog';

export default {
  name: "local-categories",
  components: {
    LocalCategoryForm,
    ConfirmDeleteDialog
  },
  data: () => ({
    loading: false,
    local_category_dialog: false,
    local_category_editing: null,
    confirm_deletion: false,
    local_category_deleting: null,
    filter: "",
    categories: [],
    options: {},
    totalItems: 0,
    headers: [
      {
        text: "",
        value: "image_url",
        sortable: false,
      },
      {
        text: "Nome",
        value: "name",
      },
      {
        text: "Ações",
        value: "actions",
        width: 50,
        sortable: false
      }
    ],
  }),
  methods: {
    handleSubmitLocalCategoryForm(item) {
      this.getLocalCategories();
      this.local_category_dialog = false;
    },
    handleCloseLocalCategoryForm(item) {
      this.local_category_dialog = false;
      this.local_category_editing = null;
    },
    handleNew() {
      this.local_category_editing = null;
      this.local_category_dialog = true;
    },
    handleEdit(item) {
      this.local_category_editing = item;
      this.local_category_dialog = true;
    },
    confirmDelete(item) {
      this.confirm_deletion = true;
      this.local_category_deleting = item;
    },
    async handleRemove() {
      try {
        await destroyLocalCategory(this.local_category_deleting?.id);
        this.$store.commit('sendMessage', {
          text: 'Tipo de produto removido com sucesso'
        })
        this.getLocalCategories();
        this.confirm_deletion = false;
      } catch(e) {
        this.$store.commit('sendMessage', {
          text: e.response.data.message,
          color: 'red'
        })
      }
    },
    async getLocalCategories() {
      this.loading = true;
      try {
        const response = await indexLocalCategories({
          filter: this.filter,
          ...this.options
        });
        
        this.categories = response.data;
        this.totalItems = response.total;
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar tipos de produtos",
          color: "red",
        });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.getLocalCategories();
      },
      deep: true,
    },
    filter: function (value) {
      if (value == null) this.getLocalCategories();
    },
  },
};
</script>